module.exports = __webpack_public_path__ + "assets/Cannerald_Shop_Icon-Cannabis.bdd872e6.svg";